export const setHoverId = (id: string | null) => {
    // @ts-ignore
    return (dispatch) => {
        dispatch({
            type: 'SET_HOVER_ID',
            payload: id
        });
    };
};

export const setActiveId = (id: string | null) => {
    // @ts-ignore
    return (dispatch) => {
        dispatch({
            type: 'SET_ACTIVE_ID',
            payload: id
        });
    };
};
